import { Alert, Box, Button, CircularProgress } from "@mui/material";
import { createFileRoute, redirect } from "@tanstack/react-router";

import { docsLoginUrl, useDocsAccessUrl } from "@/api/docs";
import { useAuth } from "@/contexts/AuthContext";
import { isDocsEnabledForUser } from "@/features/Docs/flag";

export const Route = createFileRoute("/_auth/docs/$siteId")({
  beforeLoad: ({ context }) => {
    if (!isDocsEnabledForUser(context.auth?.user)) throw redirect({ to: "/" });
  },
  component: DocsPage,
});

export const DOCS_IFRAME_TITLE = "Documentation";

// HelpKit in the app shell: loading the minted /access URL signs the iframe
// in. Site-scoped only so the nav and site selector keep working.
export function DocsPage() {
  const { user } = useAuth();
  const { data, isError, isFetching, refetch } = useDocsAccessUrl(user?.sub);

  if (data !== undefined) {
    return (
      <Box
        component="iframe"
        title={DOCS_IFRAME_TITLE}
        src={data}
        sx={{ flex: 1, width: "100%", border: 0 }}
      />
    );
  }
  if (!isError) {
    return (
      <CircularProgress aria-label="Loading documentation" sx={{ m: "auto" }} />
    );
  }
  return (
    <Alert
      severity="error"
      sx={{ m: "auto" }}
      action={
        <Button
          color="inherit"
          size="small"
          onClick={() => void refetch()}
          disabled={isFetching}
        >
          Retry
        </Button>
      }
    >
      The documentation could not be opened. You can also{" "}
      <a href={docsLoginUrl()} target="_blank" rel="noopener">
        open it in a new tab
      </a>
      .
    </Alert>
  );
}
